import { useCallback, useEffect, useState } from "preact/hooks";
import { ClubEvent } from "../types";
import { getClubEventItems } from "../api";

type Props = {
  clubId: number;
}

type ReturnType = {
  clubEvents: ClubEvent[];
  isLoading: boolean;
  errorMessage: string;
}

export const useGetClubEventItems = ({clubId}: Props): ReturnType => {
  const [clubEvents, setClubEvents] = useState<ClubEvent[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState<string | null>(null);

  const fetchClubEventItems = useCallback(async () => {
    try {
        setIsLoading(true);
        const response = await getClubEventItems(clubId);
        const result = await response.json();
        setClubEvents(result);
      } catch (error) {
        if (error.response && error.response.status === 404) {
          setErrorMessage("Club Events Not Found");
        } else {
          setErrorMessage("Something went wrong while fetching Club Events");
        }
      } finally {
        setIsLoading(false);
      }
  }, [clubId]);

  useEffect(() => {
    fetchClubEventItems();
  }, [fetchClubEventItems]);

  return { clubEvents, isLoading, errorMessage };
};
